import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import { addQuotes } from 'apps/utils';

import { Link } from 'core/routing';
import Paragraph from 'components/Paragraph';
import BaseCard from 'apps/notificationCenter/views/baseCard';

import { ContentWrapper } from 'apps/notificationCenter/styles';

const LikeCard = props => {
  const { t, notification } = props;
  const { targetDisplayType, targetApp } = notification;

  const message = targetDisplayType && (
    <ContentWrapper>
      <Paragraph>
        {t('Liked your')} <strong>{t(targetDisplayType)}</strong>
        {'. '}
        {['Thread', 'Story']?.includes(targetDisplayType) && (
          <Link {...targetApp?.route}>{targetApp?.title}</Link>
        )}
      </Paragraph>
      {targetDisplayType === 'Comment' && (
        <Paragraph as='blockquote'>{addQuotes(targetApp?.snippet)}</Paragraph>
      )}
    </ContentWrapper>
  );

  return <BaseCard notification={notification} message={message} />;
};

LikeCard.propTypes = {
  t: PropTypes.func,
  notification: PropTypes.object,
};

export default withNamespaces()(observer(LikeCard));
